module.exports = __webpack_public_path__ + "static/media/Warren G. Harding - 1920.fc9961fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Warren G. Harding - 1920.jpg
// module id = 562
// module chunks = 0